import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-regular-svg-icons/faXmark';

import { Button, ButtonType } from '../Button';
import { Modal } from '../Modal';

// Angular source: apps/angular/src/js/ng/sitter/review/review-faq-modal.*
// FAQ shown during the feedback flow.
interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export const ReviewFAQModal = ({ isOpen, onClose }: Props): JSX.Element => {
  const { t } = useTranslation();
  return (
    <Modal isOpen={isOpen} onClose={onClose} className='w-full max-w-lg'>
      <Button
        aria-label={t('common.close')}
        onClick={onClose}
        className='absolute right-2 top-2 text-gray-400 hover:text-gray-500 transition-colors'
      >
        <FontAwesomeIcon icon={faXmark} className='w-5 h-5' />
      </Button>
      <h3 className='font-semibold mb-3'>{t('components.modals.reviewFAQ.title')}</h3>
      <div className='space-y-3 text-sm mb-4'>
        <p>
          <b>{t('components.modals.reviewFAQ.q1')}</b>
          <br />
          {t('components.modals.reviewFAQ.a1')}
        </p>
        <p>
          <b>{t('components.modals.reviewFAQ.q2')}</b>
          <br />
          <Trans
            i18nKey='components.modals.reviewFAQ.a2'
            components={{
              careLink: (
                <a className='underline' href='mailto:care@urbansitter.com'>
                  care@urbansitter.com
                </a>
              ),
            }}
          />
        </p>
        <p>
          <b>{t('components.modals.reviewFAQ.q3')}</b>
          <br />
          {t('components.modals.reviewFAQ.a3')}
        </p>
      </div>
      <div className='text-right'>
        <Button buttonType={ButtonType.primary} onClick={onClose}>
          {t('components.modals.reviewFAQ.gotIt')}
        </Button>
      </div>
    </Modal>
  );
};
